/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation DltDeleteMutation($dltId: ID!) {
  DltDelete(dltId: $dltId) {
    id
    message
    status
  }
}
`
